import { render, staticRenderFns } from "./UpdateContacts.vue?vue&type=template&id=7e74ce12&"
import script from "./UpdateContacts.vue?vue&type=script&lang=js&"
export * from "./UpdateContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports